
import publicAxiosInstance from "../utils/axios/public";
import privateAxiosInstance from "../utils/axios/private";
import { hybridDecrypt } from "../utils/crypto";

/**
 * Candidate-related API calls
 */
export const landingApis = {
    async requestDemo(payload) {
        try {
            const response = await publicAxiosInstance.post("/landing/page/demo/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },
    
    async requestDemoOTP(payload) {
        try {
            const response = await publicAxiosInstance.post("/landing/page/demo/send-otp/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async verifyDemoOTP(payload) {
        try {
            const response = await publicAxiosInstance.post("/landing/page/demo/verify-otp/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async requestContact(payload) {
        try {
            const response = await publicAxiosInstance.post("/landing/page/contact/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data;
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                };
            }
            return error.response.data;
        }
    },

    async getAllDemoUser() {
        try {
            const response = await privateAxiosInstance.get("/landing/page/alldemo/");
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    async updateDemoUser(id, payload) {
        try {
            const response = await privateAxiosInstance.put(`/landing/page/update-demo/${id}/`, payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response?.data || error.message;
        }
    },

    async deleteDemoUser(id) {
        try {
            const response = await privateAxiosInstance.delete(`/landing/page/delete-demo/${id}/`);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response?.data || error.message;
        }
    },
};


